<template>
    <div class="wrap">

        <!--网页底部-->

        <div class="wrapB">
            <div class="webwrap">
                <span>合作媒体:</span>
                <ul class="web-list">
                    <li :key="index" v-for="(item, index) in partner"><a :href="item.dirlink" target="_Blank">{{item.title}}</a></li>
                </ul>
            </div>
            <hr>
            <div class="foot-wrap">
                <div class="erwei">
                    <div class="erwei-wrap">
                        <img class="erwei-img" :src="images4.logo" alt="">
                        <div>{{qr_one}}</div>
                    </div>

                    <div class="erwei-wrap">
                        <img class="erwei-img" :src="images5.logo" alt="">
                        <div>{{qr_two}}</div>
                    </div>
                </div>
                <div class="web-info">
                    <div style="font-size:15px;">
                        <router-link :to="{path:'aboutWeb'}">网站介绍</router-link>
                        -
                        <router-link :to="{path:'advertising'}">广告报价</router-link>
                    </div>
                    <div>联系邮箱：{{config.contacts_email}}</div>
                    <div>经营许可证编号：{{config.business_license}}</div>
                    <div>{{config.copyright}}</div>
                    <div>网站运营：{{config.site_operation}}</div>
                </div>
                <div class="erwei">
                    <div class="erwei-wrap">
                        <img class="erwei-img" :src="images6.logo" alt="">
                        <div>{{qr_three}}</div>
                    </div>
                    <div class="erwei-wrap">
                        <img class="erwei-img" :src="images7.logo" alt="">
                        <div>{{qr_four}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "HomeFoot",
        components: {},
        data() {
            return {
                newsClass: '',
                images4: '',
                images5: '',
                images6: '',
                images7: '',
                config: '',
                partner: '',
                qr_four: '',
                qr_one: '',
                qr_three: '',
                qr_two: '',
            }
        },
        mounted() {
            this.getNewsClass()
            this.guangGao()
            this.getWebMsg()
        },
        methods: {


// 底部网站信息
            getWebMsg() {
                this.$get("/index/index/through_train",).then((res) => {
                    if (res.code === 0) {
                        this.config = res.data.config
                        this.partner = res.data.partner
                        console.log(res.data, '网站介绍')
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            getNewsClass() {
                this.$get("/index/index/complaint_list",).then((res) => {
                    if (res.code === 0) {
                        this.newsClass = res.data
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            guangGao() {
                this.$get("/index/index/ad_position",).then((res) => {
                    if (res.code === 0) {
                        this.images6 = res.data.images[6]
                        this.images7 = res.data.images[7]
                        this.images4 = res.data.images[4]
                        this.images5 = res.data.images[5]

                        this.qr_four = res.data.qr_four
                        this.qr_one = res.data.qr_one
                        this.qr_three = res.data.qr_three
                        this.qr_two = res.data.qr_two
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
        }

    }
</script>

<style scoped lang="less">
    .wrapA {
        width: 1200px;
        margin: 0 auto;
    }

    .hengfu {
        width: 1200px;
        height: 100px;
        margin: 15px 0;
    }

    .news-wrap {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
    }

    .zhitongche {
        max-width: 1200px;
        max-height: 255px;
        background: #ecf3ff;
        padding: 22px;

        /deep/ .swiper-wrapper {
            transition-timing-function: linear !important;
        }

    }


    .hejie, .daren {
        text-align: center;
        height: 26px;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(41, 75, 127, 1);
        line-height: 26px;
        margin: 0 0 16px 0;
    }


    .img-wrap {
        text-align: center;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 19px;
        margin: 0 10px;
    }

    .hejie-daren {
        max-height: 255px;
        padding: 22px;
        border: 1px solid #ecf3ff;
        margin-top: 40px;

        /*/deep/ .swiper-wrapper {*/
        /*transition-timing-function: linear !important;*/
        /*}*/
    }

    .daren {
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: #294b7f;

    }


    .lawyer {
        border-radius: 50%;
        width: 128px;
        height: 128px
    }

    .wrapB {
        min-height: 278px;
        background: #f1f1f1;
    }

    .webwrap {
        width: 1090px;
        margin: 0 auto;
        min-height: 112px;
        position: relative;
        margin-top: 34px;
    }

    .webwrap > span {
        position: absolute;
        top: 29px;
        left: -75px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 19px;
    }

    .web-list {
        display: flex;
        flex-wrap: wrap;
        width: 1118px;
        padding-top: 24px;
    }

    .web-list > li > a {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        line-height: 32px;
        margin: 0 20px;
    }

    .foot-wrap {
        width: 1060px;
        min-width: 1060px;
        height: 165px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .erwei {
        margin-left: -32px;
        display: flex;
    }

    .erwei-wrap {
        text-align: center;
        margin-left: 32px;

    }

    .erwei-img {
        width: 88px;
        height: 88px;
    }

    .web-info {
        width: 340px;
        height: 94px;
        text-align: center;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        line-height: 16px;
        margin-top: -40px;

        div {
            margin: 5px 0;
        }
    }

</style>
